



































import FooterButton from "@/components/FooterButton.vue";
import { Component, Mixins } from "vue-property-decorator";
import { WelcomeContent } from "@/models/content/welcome";
import { ContentService } from "@/service/content.service";
import CommonMixin from "@/mixins/common-mixins";

@Component({
  components: {
    FooterButton
  }
})
export default class Welcome  extends Mixins(CommonMixin) {
  content: WelcomeContent = {} as WelcomeContent;
  textDirection = 'ltr'
  PercentDone = 20;

  async mounted(): Promise<void> {
    const contentService = new ContentService(this.$route);
    this.content = await contentService.getWelcomeContent();
    this.textDirection = contentService.TextDirection();
  }

  public handleNextPageEvent(): void {
    this.$router.push({ path: "InitialRequirements" });
  }
}
